/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Delivery_LinkInputs */

const cs_tasks_protocol_delivery_link = /** @type {(inputs: Tasks_Protocol_Delivery_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sdílitelný odkaz k podpisu`)
};

const en_tasks_protocol_delivery_link = /** @type {(inputs: Tasks_Protocol_Delivery_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shareable signing link`)
};

/**
* | output |
* | --- |
* | "Shareable signing link" |
*
* @param {Tasks_Protocol_Delivery_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_delivery_link = /** @type {((inputs?: Tasks_Protocol_Delivery_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Delivery_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_delivery_link(inputs)
	return cs_tasks_protocol_delivery_link(inputs)
});